/* eslint-disable */
<template>
    <div class="login-page">
      <LoginBackground class="background-layer"/>
      <!-- 导航栏 -->
    <!-- Navigation bar -->
    <nav class="main-nav">
      <a href="/">
        <div class="logo">
        <span class="logo-symbol"><img src="https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise-images/sunrise-logo.png" width="60" height="60" alt="小晖智能客服" style="border-radius: 10%;"/></span>
        <span>小晖AI客服平台</span>
      </div>
      </a>
    </nav>

      <!-- 登录卡片 -->
      <div class="login-wrapper">
        <LoginBackground class="background-layer"/>
        <div class="login-card">
          <!-- 登录表单 -->
          <transition name="form-fade" mode="out-in">
            <form @submit.prevent="handleLogin">
                          <!-- ★★★ 新增：页面内提示区域 ★★★ -->
            <div v-if="pageTip.show" :class="['page-tip', pageTip.type]">
              <span class="tip-icon">{{ pageTip.type === 'error' ? '✕' : '✓' }}</span>
              <span class="tip-text">{{ pageTip.message }}</span>
              <button type="button" class="tip-close" @click="pageTip.show = false">×</button>
            </div>
              <div class="form-group">
                <label for="admin-phone">手机号</label>
                <input
                  id="admin-phone"
                  v-model="form.phone"
                  type="tel"
                  pattern="1[3-9]\d{9}"
                  v-model.trim="form.phone"
                  required
                  placeholder="请输入手机号">
              </div>

              <div class="form-group">
                <label for="sms-code">短信验证码</label>
                <div class="sms-group">
                  <input
                    id="sms-code"
                    v-model="form.code"
                    type="text"
                    required
                    placeholder="6位验证码">
                  <button
                    type="button"
                    class="sms-btn"
                    :disabled="isCountingDown || !isPhoneValid"
                    @click="sendSMSCode">
                    <span v-if="!loading_sms">
                    {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}
                    </span>
                    <span v-else>
                      <i class="el-icon-loading"></i> 发送中...
                    </span>
                  </button>
                </div>
              </div>
 <input type="checkbox" id="checkbox1" v-model="agreement" value="Jack">              
  <label for="checkbox1">我已阅读并同意 </label><span class="link" @click="HandleLicense">小晖AI客服平台用户服务协议</span> 、 <span @click="HandleAcceptable" class="link">可接受使用政策</span>、<span @click="HandlePrivacy" style="margin-right:30px" class="link">隐私政策</span>和<span @click="HandleDataProtection" style="margin-right:30px;margin-left: 10px;" class="link">数据保护协议</span>
              <button type="submit" class="submit-btn">
                <span v-if="!loading_login">登  录</span>
                <span v-else>
                      <i class="el-icon-loading"></i> 登录中...
                    </span>
              </button>

              <div class="footer-links">
                <router-link to="/password-login">使用账号密码登录</router-link>
                <router-link to="/register" class="register-link">注  册</router-link>
              </div>
            </form>
          </transition>
        </div>
      </div>

            <!-- 服务协议对话框 -->
      <el-dialog title="小晖AI客服平台用户服务协议" :visible.sync="open_licence" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="licenceContent"></div>
      </div>
    </el-dialog>
      <!-- 隐私政策对话框 -->
      <el-dialog title="小晖AI客服平台可接受使用政策" :visible.sync="open_acceptable" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="acceptableContent"></div>
      </div>
    </el-dialog>

          <!-- 隐私政策对话框 -->
      <el-dialog title="小晖AI客服平台隐私政策" :visible.sync="open_privacy" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="privacyContent"></div>
      </div>
    </el-dialog>    

      <!-- 数据保护协议对话框 -->
      <el-dialog title="小晖AI客服平台数据保护协议" :visible.sync="open_dataprotection" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="dataprotectionContent"></div>
      </div>
    </el-dialog>   
    </div>
  </template>

<script>
import LoginBackground from '@/components/LoginBackground.vue'
import { send_sms_code } from '@/api/common'
import {getUserAgeement, getAcceptable, getPrivacy, getDataprotectionContent} from '@/api/tenant/agreement'

export default {
  name: 'LoginView',
  components: {
    LoginBackground
  },
  data() {
    return {
      countdownTimer: null,
      countdown: 0,
      loading_sms: false,
      loading_login: false,
      isPhoneValid: true,
      agreement: false,
      form: {
        phone: '',
        code: ''
      },
      loading: false,
      smsError: '',  // 新增
      // ★★★ 新增：页面提示数据 ★★★
      pageTip: {
        show: false,
        type: 'error',  // 'error' 或 'success'
        message: ''
      },

      // 用户服务协议
      open_licence: false,
      licenceContent: '-',
      // 可接受使用政策
      open_acceptable: false,
      acceptableContent: "-",
      // 隐私政策
      open_privacy: false,
      privacyContent: '-',
      // 数据保护协议
      open_dataprotection: false,
      dataprotectionContent: ''
    }
  },
  computed: {
    isCountingDown() {
      return this.countdown > 0
    },
  },

      beforeDestroy() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
    },
  created() {
  },
  methods: {
    // ★★★ 新增：页面提示方法 ★★★
    showPageTip(message, type = 'error', duration = 4000) {
      this.pageTip.message = message
      this.pageTip.type = type
      this.pageTip.show = true
      // 自动关闭
      if (this.pageTip.timer) clearTimeout(this.pageTip.timer)
      this.pageTip.timer = setTimeout(() => {
        this.pageTip.show = false
      }, duration)
    },    
    validatePhone(phone) {
      let isPhoneValid = /^1[3-9]\d{9}$/.test(phone)
      if (!isPhoneValid) {
        this.showPageTip('请输入正确的手机号')
      }
      return isPhoneValid
    },
    async sendSMSCode() {
      if (this.isCountingDown || !this.
      validatePhone(this.form.phone)) return;
      console.log('sendSMSCode:', this.form.phone);
      this.loading_sms = true;
      try {
        const response = await send_sms_code(this.form.phone)
        console.log(response.status, response.data);
        if (response.data && response.status === 200 && response.data.code === 200) {
          this.startCountdown();
          this.showPageTip('验证码已发送', 'success')
          this.loading_sms = false;
          this.smsError = '';
        } else {
          this.loading_sms = false;
          this.smsError = (response.data && response.data.message) || '发送验证码失败';
          this.showPageTip(this.smsError);
        }
      } catch (error) {
        this.smsError = (error.response && error.response.data && error.response.data.message) || '发送验证码失败';
        this.loading_sms = false;
        this.showPageTip(this.smsError, 'error');
      }
    },
    startCountdown() {
      this.countdown = 60;
      localStorage.setItem('smsCountdown', Date.now() + 60000);

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          localStorage.removeItem('smsCountdown');
        }
      }, 1000);
    },
    checkCountdown() {
      console.log('checkCountdown');
      const savedTime = localStorage.getItem('smsCountdown');
      console.log(savedTime);
      if (savedTime) {
        const remainingTime = Math.ceil((parseInt(savedTime) - Date.now()) / 1000);
        if (remainingTime > 0) {
          this.countdown = remainingTime;
          this.startCountdown();
        } else {
          localStorage.removeItem('smsCountdown');
        }
      }
    },
    HandleAcceptable(){
      this.open_acceptable = true
      this.acceptableContent = getAcceptable();
    },
    //隐私政策对话框
     HandlePrivacy() {
       this.open_acceptable = false
        this.open_privacy = true;
        this.privacyContent = getPrivacy();
    },
    HandleDataProtection(){
             this.open_acceptable = false
        this.open_privacy = false;
        this.open_dataprotection = true;
        this.dataprotectionContent = getDataprotectionContent();
    },
    async handleLogin() {
      try {
        console.info("this.agreement", this.agreement)
        if (!this.agreement) {
           this.showPageTip('请阅读并同意《小晖AI客服平台用户服务协议》、《可接受使用政策》、《隐私政策》、《数据保护协议》', 'error', 5000)
          return;
        }
        this.loading_login = true
        const result = await this.$store.dispatch('auth/sms_login', {
          credentials: {
            'phone': this.form.phone,
            code: this.form.code
          }
        })
        console.log('登录结果:', result);
        if (result && result.success) {
          if (result.tenantUserInfo != null && result.employeeUserInfo == null
            && result.tenantUserInfo.status == 'APPROVED') {
            this.$router.push('/admin/main');
          } else if (result.tenantUserInfo != null && result.employeeUserInfo != null) {
            this.$router.push('/employee/workspace');
          } else if ((result.tenantUserInfo == null || result.tenantUserInfo.status !== 'APPROVED') && result.employeeUserInfo == null) {
            this.$router.push('raw_user/home');
          }
        } else {
            this.showPageTip(result.message,'error')
        }
        this.loading_login = false;
      } catch (error) {
        this.loading_login = false
        this.showPageTip('登录失败，请重试', 'error')
        console.log('登录错误详情:', error)
      } finally {
        this.loading = false
        this.loading_login = false
      }
    },
    showError(message) {
      this.errorMessage = message
      setTimeout(() => {
        this.errorMessage = ''
      }, 3000)
    },
    HandleLicense() {
      this.open_licence = true;
      this.licenceContent =getUserAgeement();
    },
  }
}
</script>

<style scoped lang="scss">
// 1. 先导入外部文件
@import '@/styles/variables.scss';
@import '@/styles/public-theme1.scss';

// 2. 再写自定义样式
.background-layer {
  position: fixed;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.main-nav,
.login-wrapper {
  position: relative;
  z-index: 1;
  padding: 0;
}

.login-page {
  min-height: 100vh;
  background: $light-bg;
  margin-top: 2px;

  .main-nav {
    padding: 15px;
    background: rgba($space-blue, 0.9);

    .logo {
      display: flex;
      align-items: center;
      color: $pure-white;
      font-size: 1.4rem;
      font-weight: 600;

      .logo-symbol {
        font-family: 'Fira Code', monospace;
        color: $electric-blue;
        font-size: 2rem;
        margin-right: 12px;
      }
    }
  }
}

.login-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 92px);
  padding: 40px 20px;
}

.login-card {
  width: 100%;
  max-width: 560px;
  background: $pure-white;
  border-radius: 16px;
  box-shadow: 0 12px 48px rgba($space-blue, 0.15);
  padding: 56px 60px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid $gray-border;
  margin-bottom: 36px;

  button {
    flex: 1;
    padding: 20px 0;
    font-size: 1.1rem;
    font-weight: 500;
    color: lighten($space-blue, 30%);
    background: none;
    border: none;
    cursor: pointer;
    position: relative;
    transition: all 0.3s;

    &.active {
      color: $electric-blue;
      font-weight: 600;

      &::after {
        content: "";
        position: absolute;
        bottom: -1px;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        height: 4px;
        background: $electric-blue;
        border-radius: 4px 4px 0 0;
      }
    }
  }
}

.form-group {
  margin-bottom: 32px;

  label {
    display: inline-block;
    width: 120px;
    margin-bottom: 14px;
    font-size: 1.05rem;
    color: #474747;
    font-weight: 500;
  }

  input {
    display: inline-block;
    width: calc(100% - 132px);
    padding: 16px 20px;
    border: 1px solid $gray-border;
    border-radius: 10px;
    font-size: 1.05rem;
    transition: all 0.3s;

    &:focus {
      border-color: $electric-blue;
      box-shadow: 0 0 0 3px rgba($electric-blue, 0.15);
    }
  }
}

.sms-group {
  display: inline-flex;
  align-items: center;
  width: calc(100% - 132px);

  input {
    flex: 1;
  }

  .sms-btn {
    background: $electric-blue;
    color: white;
    border: none;
    padding: 0 20px;
    margin-left: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
    height: 54px;
    border-radius: 10px;
    
    &:disabled {
      background: #DDD;
      cursor: not-allowed;
    }
  }
}

.submit-btn {
  width: 100%;
  padding: 18px;
  margin: 40px 0 30px;
  background: $electric-blue;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1.15rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba($electric-blue, 0.3);
  }
}

.footer-links {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;

  a {
    color: lighten($space-blue, 20%);
    font-size: 0.95rem;
    text-decoration: none;
    transition: color 0.3s;
    padding: 8px 0;

    &:hover {
      color: $electric-blue;
      text-decoration: underline;
    }
  }

  .register-link {
    font-weight: 600;
    color: $electric-blue;
  }
}

.form-fade-enter-active,
.form-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.form-fade-enter,
.form-fade-leave-to {
  opacity: 0;
  transform: translateX(10px);
}

@media (max-width: 768px) {
  .login-card {
    padding: 40px 32px;
    margin: 0 20px;
  }

  .tabs {
    margin-bottom: 28px;

    button {
      padding: 16px 0;
      font-size: 1rem;
    }
  }

  .form-group {
    margin-bottom: 28px;

    label {
      margin-bottom: 12px;
      font-size: 1rem;
    }

    input {
      padding: 14px 16px;
    }
  }

  .submit-btn {
    margin: 32px 0 24px;
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 32px 24px;
  }

  .footer-links {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
}

.link {
  color: $electric-blue;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
}

/* checkbox 样式 - 只保留一份 */
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 26px;
  height: 26px;
  border: 2px solid $electric-blue;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s;
  flex-shrink: 0;
}

input[type="checkbox"]:checked {
  background-color: $electric-blue;
  border-color: $electric-blue;
}

input[type="checkbox"]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 18px;
  font-weight: bold;
}

input[type="checkbox"]:hover {
  border-color: darken($electric-blue, 10%);
}

/* 页面提示区样式 */
.page-tip {
  display: flex;
  align-items: center;
  padding: 12px 42px 12px 16px;
  margin-bottom: 20px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  position: relative;
  animation: tipSlideDown 0.3s ease;

  &.error {
    background: #fef0f0;
    border: 1px solid #fde2e2;
    color: #f56c6c;

    .tip-icon {
      background: #f56c6c;
    }
  }

  &.success {
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    color: #67c23a;

    .tip-icon {
      background: #67c23a;
    }
  }

  .tip-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    color: white;
    font-size: 12px;
    font-weight: bold;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .tip-text {
    flex: 1;
  }

  .tip-close {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 20px;
    color: inherit;
    cursor: pointer;
    padding: 0 4px;
    line-height: 1;
    opacity: 0.6;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }
}

@keyframes tipSlideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>